module.exports = __webpack_public_path__ + "img/Rx40-512.51086265.png";